import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Features/Status_LED/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import StatusTable from 'components/Web_User_Interface/1440p_Series/Features/Status_LED/statusTable';
import SignalTable from 'components/Web_User_Interface/1440p_Series/Features/Status_LED/signalTable.jsx';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PermissionBox,
  StatusTable,
  SignalTable,
  BreadCrumbs,
  SEOHelmet,
  React
};